import { render } from "./vhpSimpleCard.vue?vue&type=template&id=0cd17f2c&scoped=true"
import script from "./vhpSimpleCard.vue?vue&type=script&lang=js"
export * from "./vhpSimpleCard.vue?vue&type=script&lang=js"

import "./vhpSimpleCard.scss?vue&type=style&index=0&id=0cd17f2c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd17f2c"]])

export default __exports__